// Case-study entries. Intentionally EMPTY — publish only genuine, documented
// LEDOS projects. Do not populate with fictitious work.
// Entry schema:
// {
//   slug: string,
//   projectName: string,
//   client: string,            // or "Anonymous Client"
//   industry: string,
//   location: string,
//   numLocations: string,
//   challenge: string,
//   scopeOfWork: string[],
//   equipment: string[],
//   solution: string,
//   results: string[],
//   photos: string[],          // genuine project photos only
// }
export const CASE_STUDIES = [];
